export default __webpack_public_path__ + "static/media/296.53bbe9da.jpg";